import axios from 'axios'
import * as FileSaver from 'file-saver'
import { CATALOGO_ENDPOINT } from '../../endpoints'
import { XML_TYPE } from 'Utilities'

const FILE_NAME_BY_PARAMS = {
  'conventional|byProduct': 'Descuento por producto convencional.xlsx',
  'conventional|byStock': 'Descuento por stock convencional.xlsx',
  'used|byStock': 'Descuento por stock usados.xlsx',
}

function getExportFileName(businessType, discountType) {
  const key = `${businessType}|${discountType}`
  return FILE_NAME_BY_PARAMS[key] || 'Bonificaciones.xlsx'
}

async function readBlobAsJson(blob) {
  const text = await blob.text()
  try {
    return JSON.parse(text)
  } catch (e) {
    return null
  }
}

async function normalizeAxiosBlobError(error) {
  const data = error?.response?.data
  const status = error?.response?.status
  if (data instanceof Blob && status && status >= 400) {
    const json = await readBlobAsJson(data)
    if (json?.message) throw new Error(json.message)
    if (typeof json === 'object' && json?.error) throw new Error(json.error)
    throw new Error('No se pudo generar el archivo.')
  }
  throw error
}


// Descarga Excel de bonificaciones.
export async function getGenerateBonificationsPriceExcel({
  carLotId,
  businessType,
  discountType,
}) {
  const params = new URLSearchParams({
    businessType,
    discountType,
  })
  const url = `${CATALOGO_ENDPOINT}/generateBonificationsPriceExcel/${carLotId}?${params.toString()}`
  try {
    const response = await axios.get(url, {
      responseType: 'blob',
      timeout: 300000,
    })

    const contentType = response.headers['content-type'] || ''
    if (contentType.includes('application/json')) {
      const json = await readBlobAsJson(response.data)
      const message = json?.message || json?.error || 'No se pudo generar el archivo.'
      throw new Error(message)
    }

    const fileName = getExportFileName(businessType, discountType)
    const file = new Blob([response.data], { type: XML_TYPE })
    FileSaver.saveAs(file, fileName)
  } catch (err) {
    throw await normalizeAxiosBlobError(err)
  }
}
